import { jsxs as i, jsx as t } from "react/jsx-runtime";
const e = (s) => /* @__PURE__ */ i("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 32 24", ...s, children: [
  /* @__PURE__ */ t(
    "path",
    {
      fill: "#F0F0FF",
      stroke: "#D9D8FF",
      d: "M.5 3A2.5 2.5 0 0 1 3 .5h26A2.5 2.5 0 0 1 31.5 3v18a2.5 2.5 0 0 1-2.5 2.5H3A2.5 2.5 0 0 1 .5 21V3Z"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      fill: "#4945FF",
      d: "M14.907 9.438c0 .375 0 .738.118 1.078-1.243 1.46-4.526 5.317-4.832 5.611a.582.582 0 0 0-.193.433c0 .245.15.481.277.614.19.2 1.004.952 1.154.808.444-.433.533-.548.715-.727.274-.268-.029-.816.066-1.039.096-.222.197-.265.361-.3.165-.034.456.084.684.087.24.003.369-.098.548-.265.144-.133.248-.257.25-.45.007-.26-.368-.603-.089-.877.28-.274.684.178.981.144.297-.035.658-.447.695-.623.038-.176-.337-.629-.28-.886.02-.086.197-.288.33-.317.132-.029.72.199.853.17.162-.034.35-.205.502-.3.447.193.854.271 1.376.271C20.4 12.87 22 11.33 22 9.432 22 7.534 20.399 6 18.423 6s-3.516 1.54-3.516 3.438Zm5.247-.669a.923.923 0 1 1-1.847 0 .923.923 0 0 1 1.847 0Z"
    }
  )
] }), o = e;
export {
  o as default
};
